import { Stack, styled } from '@mui/material';
import fill from 'lodash/fill';

import type { OfferMemberProgress } from '@ocx/data-offers';
import { Typography, SizingMultiplier } from '@ocx/ui';
import { CheckmarkIcon } from '@ocx/ui-icons';

export const PUNCHES_TEST_ID = 'offer_membership_punches';
interface StyledPunchProps {
  isActive: boolean;
}

const StyledPunch = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<StyledPunchProps>(({ theme, isActive }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: isActive ? 'none' : `1px solid ${theme.palette.divider}`,
  borderRadius: '50%',
  width: 24,
  height: 24,
  color: isActive ? theme.palette.primary.contrastText : theme.palette.text.disabled,
  backgroundColor: isActive ? theme.palette.primary.main : 'transparent',
}));

export const Punches = ({ required, achieved }: OfferMemberProgress) => {
  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      rowGap={SizingMultiplier.sm}
      gap={SizingMultiplier.sm}
      data-testid={PUNCHES_TEST_ID}>
      {fill(Array(required), null).map((value, index) => {
        const isActive = achieved > index;

        return (
          <StyledPunch key={`punch_${index}`} isActive={isActive}>
            {isActive ? (
              <CheckmarkIcon sx={{ width: 16, height: 12 }} />
            ) : (
              <Typography variant="body2" color="inherit">
                {index + 1}
              </Typography>
            )}
          </StyledPunch>
        );
      })}
    </Stack>
  );
};
